import './components/acc';
import './components/anchor';

import './components/module3D';
import './components/blog';

import './components/customFilters';
import './components/townMap';
import './components/dinamicHeight';
import './components/fancybox';
import './components/financialAnimation';
import './components/form-validate';
import './components/mobile-menu';
import './components/modals';
import './components/profitAnimation';
import './components/provinceSelect';
import './components/roadmap';
import './components/sliders';
import './components/tabs';
import './components/townAreas';
import './components/contactsMap';